export var getIds = function getIds(id) {
  return id ? {
    root: "".concat(id, "__double-month-root"),
    left: "".concat(id, "__double-month-left"),
    right: "".concat(id, "__double-month-right")
  } : undefined;
};
//# sourceMappingURL=getIds.js.map